import { useCallback } from 'react';
import { fetchOtherListings, pickDataForListing } from '../data/api/search';

export function useStoreListingApi() {
  const getOtherListings = useCallback(
    (id: string | number, exclude: string | null, page: number) => fetchOtherListings(id, exclude, page),
    []
  );

  const pickForListing = useCallback(
    (list: Parameters<typeof pickDataForListing>[0], max?: number) => pickDataForListing(list, max),
    []
  );

  return {
    fetchOtherListings: getOtherListings,
    pickDataForListing: pickForListing,
  };
}
